import { render, staticRenderFns } from "./leaderboardRequestHistory.vue?vue&type=template&id=1bed8536&"
import script from "./leaderboardRequestHistory.vue?vue&type=script&lang=js&"
export * from "./leaderboardRequestHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports